/**
 * 文档类型枚举
 */
export enum DocumentType {
    /** 专利申请 */
    PATENT_DRAFT = 'patent_draft',
    /** 交底书 */
    DISCLOSURE = 'disclosure',
    /** 权利要求 */
    PATENT_CLAIM = 'patent_claim',
    /** 说明书 */
    SPECIFICATION = 'specification',
    /** 审查意见答复 */
    PROSECUTION = 'prosecution',
    /** 技术文档 */
    TECHNICAL_DOC = 'technical_doc',
    /** 其他 */
    OTHER = 'other'
}

/**
 * 工作模式枚举
 */
export enum WorkMode {
    /** Agent 模式 */
    AGENT = 'agent',
    /** Copilot 模式 */
    COPILOT = 'copilot'
}

/**
 * 专利局/地区枚举
 */
export enum PatentRegion {
    /** 美国 */
    US = 'US',
    /** 中国 */
    CN = 'CN',
    /** 欧洲专利局 */
    EP = 'EP',
    /** 日本 */
    JP = 'JP',
    /** 韩国 */
    KR = 'KR',
    /** 世界知识产权组织 */
    WIPO = 'WIPO'
}

/**
 * 样式分类枚举
 */
export enum StyleCategory {
    /** 系统样式 */
    SYSTEM = 'system',
    /** 用户样式 */
    USER = 'user',
    /** 全部样式 */
    ALL = 'all'
}

/**
 * 样式来源类型枚举
 */
export enum StyleSourceType {
    /** 手动创建 */
    MANUAL = 'manual',
    /** 专利引用 */
    REFERENCE = 'reference'
}

/**
 * Agent 类型枚举
 */
export enum AgentType {
    /** 交底书 */
    DISCLOSURE = 'disclosure',
    /** 专利申请 */
    PATENT_DRAFT = 'patent_draft',
    /** 审查意见答复 */
    PROSECUTION = 'prosecution'
}

/**
 * 附件分类枚举
 */
export enum AttachmentCategory {
    /** 交底书 */
    DISCLOSURE = 'Disclosure',
    /** 申请 */
    APPLICATION = 'Application',
    /** 审查意见答复 */
    PROSECUTION = 'Prosecution',
    /** 其他 */
    OTHER = 'Other'
}
